import { Streamdown } from "streamdown";
import { cn } from "@/lib/utils";
import { scrubVendorTerms } from "@/lib/vendorTerms";
import ChatMarkdownImage from "./ChatMarkdownImage";
import { UUID_MARKDOWN_COMPONENTS } from "./chatUuidPills";
import "streamdown/styles.css";

const LINK_SAFETY = { enabled: false };

const MARKDOWN_COMPONENTS = {
  ...UUID_MARKDOWN_COMPONENTS,
  img: ChatMarkdownImage,
};

type ChatMarkdownProps = {
  content: string;
  isAnimating?: boolean;
  className?: string;
};

export default function ChatMarkdown({
  content,
  isAnimating = false,
  className,
}: ChatMarkdownProps) {
  return (
    <div className={cn("streamdown-chat min-w-0", className)}>
      <Streamdown
        mode="streaming"
        isAnimating={isAnimating}
        controls={false}
        lineNumbers={false}
        linkSafety={LINK_SAFETY}
        components={MARKDOWN_COMPONENTS}
      >
        {scrubVendorTerms(content)}
      </Streamdown>
    </div>
  );
}
